export default "__VITE_ASSET__DJ4ZbwcC__"